import { Badge } from '@savvy-kit/components/badge';

import type { BadgeCellContentProps } from '../../types/cell-types';

export function BadgeCellContent({ label, variant = 'primary', type = 'default', className }: BadgeCellContentProps) {
  return (
    <Badge variant={variant} type={type} className={className}>
      {label}
    </Badge>
  );
}
